import { render } from "./ManageAccount.vue?vue&type=template&id=4062df94&ts=true"
import script from "./ManageAccount.vue?vue&type=script&lang=ts"
export * from "./ManageAccount.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__